function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitpayLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 379 134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-73.6,-73.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "y_2_",
    d: "M452.3,104.6L432.6,104.6L421.2,152.7L419.6,159.3C418.5,159.6 417.4,159.9 416.3,160.1C414.3,160.5 412.2,160.7 410,160.7C407.5,160.7 405.5,160.3 404,159.6C402.6,158.9 401.5,157.9 400.9,156.5C400.3,155.2 400.1,153.6 400.2,151.8C400.3,150 400.7,148 401.2,146L407.2,121L411.1,104.4L391,104.4L381.9,142.8C380.8,147.4 380.2,151.8 380,156C379.8,160.2 380.5,163.8 381.9,167.1C383.3,170.3 385.8,172.8 389.2,174.7C392.6,176.6 397.5,177.5 403.7,177.5C408,177.5 411.8,177.1 415,176.4C415.1,176.4 415.3,176.3 415.4,176.3C414.5,180.3 412.7,183.5 409.9,186C407,188.5 402.8,189.8 397.2,189.8C394.8,189.8 392.6,189.7 390.6,189.4L386.7,205.7C389.3,206 392.2,206.2 395.4,206.2C401.4,206.2 406.6,205.5 411.1,204.2C415.6,202.8 419.4,200.8 422.7,198C425.9,195.2 428.6,191.7 430.8,187.6C433,183.4 434.7,178.5 436,172.7L449.6,115.5L452.3,104.6Z",
    style: {
      fill: "rgb(42,63,144)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a_2_",
    d: "M369.8,145.7C368.6,150.7 368.2,155.8 368.7,160.8C369.2,165.9 371.2,173.6 373.1,177.5L354.1,177.5C351.8,173.6 351.9,171.7 351.4,170.5C348.9,172.5 346.2,174.2 343.2,175.5C340.2,176.8 336.9,177.5 333.1,177.5C328.7,177.5 324.9,176.7 321.8,175.2C318.7,173.7 316.1,171.6 314.1,169C312.1,166.4 310.7,163.4 309.8,159.9C308.9,156.4 308.5,152.7 308.5,148.7C308.5,142.6 309.6,136.9 311.7,131.5C313.9,126.1 316.9,121.4 320.7,117.4C324.5,113.4 333.8,104.5 349,104.5C355.6,104.5 364.4,104.5 379.5,104.5L369.8,145.7ZM355.9,121.2C346.7,121.2 345,121.2 341.2,123.1C338.5,124.5 336.3,126.6 334.4,129C332.5,131.4 330.9,134.2 329.8,137.4C328.7,140.6 328.1,143.9 328.1,147.3C328.1,151.5 328.8,154.9 330.2,157.4C331.6,159.9 334.2,161.1 338,161.1C340,161.1 341.9,160.7 343.5,159.9C345.1,159.1 346.9,157.8 348.7,155.9C348.9,153.7 349.2,151.4 349.6,149C350,146.6 350.5,144.3 350.9,142.3L355.9,121.2",
    style: {
      fill: "rgb(42,63,144)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "p_2_",
    d: "M303.1,133.5C303.1,140 302,145.9 299.9,151.3C297.8,156.7 294.8,161.3 291,165.2C287.2,169.1 282.7,172.1 277.4,174.3C272.1,176.5 266.4,177.6 260.2,177.6C257.2,177.6 254.2,177.3 251.1,176.8L245.1,200.9L225.4,200.9L248.3,104.7C251.6,104.7 269.2,104.7 274.6,104.7C279.6,104.7 283.9,105.5 287.4,107C291,108.5 293.9,110.6 296.3,113.2C298.6,115.8 300.3,118.9 301.4,122.4C302.6,125.8 303.1,129.5 303.1,133.5ZM254.8,160.8C256.3,161.2 258.2,161.3 260.4,161.3C263.9,161.3 267,160.7 269.9,159.4C272.7,158.1 275.2,156.3 277.2,154C279.2,151.7 280.7,148.9 281.9,145.7C283,142.5 283.6,138.9 283.6,135C283.6,131.2 282.8,127.9 281.1,125.3C279.4,122.6 276.5,121.2 272.3,121.2C269.4,121.2 264.5,121.2 264.5,121.2L254.8,160.8Z",
    style: {
      fill: "rgb(42,63,144)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "t_2_",
    d: "M213.4,160.8C210.9,160.8 208.9,160.4 207.4,159.7C206,159 204.9,158 204.3,156.6C203.7,155.3 203.5,153.7 203.6,151.9C203.7,150.1 204.1,148.1 204.6,146.1L210.6,121.1L233,121.1L237.1,104.5L214.6,104.5L219.8,83.5L198.8,86.8L185.5,143C184.4,147.6 183.8,152 183.6,156.2C183.4,160.4 184.1,164 185.5,167.3C186.9,170.5 189.4,173 192.8,174.9C196.2,176.8 201.1,177.7 207.3,177.7C211.6,177.7 215.4,177.3 218.6,176.6C218.9,176.5 219.4,176.4 219.7,176.3L223.8,159.2C222.4,159.7 221,160 219.7,160.2C217.7,160.6 215.6,160.8 213.4,160.8Z",
    style: {
      fill: "rgb(42,63,144)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "i_bottom_6_",
    d: "M163.3,104.6L145.9,177.6L165.6,177.6L182.9,104.6L163.3,104.6Z",
    style: {
      fill: "rgb(42,63,144)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "i_top_2_",
    d: "M185,96.2L188,83.5L168.3,83.5L165.3,96.2L185,96.2Z",
    style: {
      fill: "rgb(42,63,144)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b_2_",
    d: "M119.7,104.7C123.9,104.7 127.6,105.5 130.7,107C133.8,108.5 136.3,110.5 138.4,113.1C140.4,115.7 141.9,118.7 142.9,122.1C143.9,125.5 144.4,129.2 144.4,133.2C144.4,139.3 143.3,145 141,150.5C138.7,155.9 135.7,160.7 131.8,164.7C127.9,168.7 123.3,171.9 118,174.2C112.7,176.5 107,177.7 100.8,177.7C100,177.7 98.6,177.7 96.6,177.6C94.6,177.6 92.3,177.4 89.8,177C87.2,176.6 84.5,176.1 81.7,175.4C78.8,174.7 76.1,173.7 73.6,172.5L96.5,76.3L117,73.1L108.9,107.2C110.7,106.4 112.3,105.8 114.1,105.4C115.8,104.9 117.7,104.7 119.7,104.7ZM102.5,161.3C105.6,161.3 108.5,160.6 111.2,159C113.9,157.5 116.3,155.5 118.3,153C120.3,150.5 121.9,147.6 123,144.5C124.1,141.3 124.7,138 124.7,134.6C124.7,130.4 124,127.1 122.6,124.7C121.2,122.3 118.3,121.2 114.5,121.2C113.3,121.2 112,121.3 110,121.8C108,122.2 106.3,123.2 104.7,124.6L96.1,160.9C98.7,161.3 101.5,161.3 102.5,161.3Z",
    style: {
      fill: "rgb(42,63,144)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitpayLogoBlue);
export default __webpack_public_path__ + "static/media/bitpay-logo-blue.7b27d7279ae35ce38e33e29837c489a0.svg";
export { ForwardRef as ReactComponent };